import { matchPath } from 'react-router-dom';

// ----------------------------------------------------------------------

export { default as NavSectionVertical } from './vertical';
export { default as NavSectionHorizontal } from './horizontal';

export function isExternalLink(path) {
  return path.includes('http');
}

export function getActive(path, pathname) {
  if (Array.isArray(path)) {
    let is_true = false;
    path.map((item) =>
      item
        ? !!matchPath({ path: item, end: false }, pathname)
          ? (is_true = true)
          : void 0
        : void 0
    );
    return is_true;
  } else {
    return path ? !!matchPath({ path, end: false }, pathname) : false;
  }
}
